import { render, staticRenderFns } from "./alertExample.vue?vue&type=template&id=aaec5232&"
import script from "./alertExample.vue?vue&type=script&lang=js&"
export * from "./alertExample.vue?vue&type=script&lang=js&"
import style0 from "./alertExample.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports